<template lang="html">
  <div>
    <div class="container" style="border-bottom:none;">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
      >
        <el-col :span="12">
          <div class="grid-content">
            <h3>今日推荐设置</h3>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="form-container">
        <el-form
          ref="nodeForm"
          :model="nodeForm"
          :rules="nodeFormRules"
          label-position="right"
          label-width="120px"
        >
          <h5>基本信息</h5>
          <el-form-item
            label="整体显示"
            prop="enable"
          >
            <el-switch
              v-if="nodeForm.hasOwnProperty('enable')"
              v-model="nodeForm.enable"
              v-loading="switchLoading"
              element-loading-text="处理中"
              element-loading-spinner="el-icon-loading"
              :disabled="switchLoading"
            >
            </el-switch>
          </el-form-item>
          <el-form-item
            label="自动推荐"
            prop="auto_update"
          >
            <el-switch
              v-if="nodeForm.hasOwnProperty('auto_update')"
              v-model="nodeForm.auto_update"
              v-loading="switchLoading"
              element-loading-text="处理中"
              element-loading-spinner="el-icon-loading"
              :disabled="switchLoading"
            >
            </el-switch>
          </el-form-item>
          <!-- <el-form-item
            label="轮播速度"
            prop="duration"
          >
            <el-input
              v-if="nodeForm.hasOwnProperty('duration')"
              type="number"
              :min="500"
              :max="120000"
              v-model.number="nodeForm.duration"
              placeholder="轮播卡片切换间隔的秒数"
            >
              <template slot="append">毫秒/张</template>
            </el-input>
          </el-form-item> -->
          <template v-if="!nodeForm.auto_update">
            <h5>人工推荐</h5>
            <el-form-item
              label="添加推荐"
              pop="swipeItems"
            >
              <el-autocomplete
                style="width:100%"
                v-model="state"
                :fetch-suggestions="querySearchAsync"
                :trigger-on-focus="true"
                :placeholder="autocompletePlaceholder"
                @input="autocompleteInputChange"
                @select="handleSelect"
              >
                <!-- <el-select v-model="cardTypeSelect" slot="prepend" placeholder="选择卡片类型">
                  <el-option label="单集" value="episode"></el-option>
                  <el-option label="主题" value="topic"></el-option>
                </el-select> -->
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-autocomplete>
            </el-form-item>
            <template v-if="nodeFormTodayRecommend.items.length > 0">
              <el-form-item
                label="管理单集"
                pop=""
              >
                <el-tree
                  ref="nodeFormTodayRecommend"
                  :data="nodeFormTodayRecommend.items"
                  node-key="objectId"
                  :highlight-current="true"
                  :draggable="true"
                  :show-checkbox="true"
                  :check-on-click-node="true"
                  :allow-drop="allowDrop"
                  @check-change="checkChange"
                  class="tree-container"
                >
                  <div slot-scope="node">
                    <draggable-episode-bar
                      v-if="node.data.objectType=='episode'"
                      :episode-id="node.data.objectId"
                    />
                    <draggable-topic-bar
                      v-if="node.data.objectType=='topic'"
                      :topic-id="node.data.objectId"
                    />
                  </div>
                </el-tree>
                <div class="custom-container">
                  <div class="info-bar">
                    <i class="el-icon-info" style="font-size:1.2em;"></i>
                    <p style="margin-left:5px">拖动排序、勾选移除</p>
                  </div>
                  <div
                    class="remove-btn"
                    :style="{visibility: checkedItems.length>0 ? 'visible' : 'hidden'}"
                  >
                    <el-button
                      size="mini"
                      type="warning"
                      plain
                      icon="el-icon-remove"
                      @click="removeCheckedItems"
                    >
                      移除选中卡片 ({{checkedItems.length}})
                    </el-button>
                  </div>
                </div>
              </el-form-item>
            </template>
          </template>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitForm"
            >提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '../router'
  import DraggableEpisodeBar from './draggable-episode-bar.vue'
  import DraggableTopicBar from './draggable-topic-bar.vue'
  import { Tree } from 'element-ui'
  import { Message } from 'element-ui'
  import { Tag } from 'element-ui'
  import { Switch } from 'element-ui'
  import { Alert } from 'element-ui'
  import { Select } from 'element-ui'
  import { Autocomplete } from 'element-ui'
  import Vue from 'vue'
  Vue.use(Tag, Switch, Alert)
  Vue.use(Select)
  Vue.use(Autocomplete)
  Vue.use(Tree)

  export default {
    components: {
      DraggableEpisodeBar,
      DraggableTopicBar
    },
    data() {
      return {
        showSlug: this.$route.params.slug,
        nodeForm: {},
        nodeFormTodayRecommend: {
          items: []
        },
        nodeFormRules: {
          duration: [
            {
              required: true,
              message: '请设置轮播速度',
              trigger: 'blur'
            },
            {
              type: 'number',
              message: '只能填写数字',
              trigger: 'blur'
            }
          ]
        },
        switchLoading: false,
        cardTypeSelect: 'episode',
        autocompletePlaceholder: '',
        // itemIds: [],
        // items: [],
        state: '',
        checkedItems: []
      }
    },
    watch: {
      cardTypeSelect: {
        handler: function (type) {
          let placeholder = ''
          switch (type) {
            case 'episode':
              placeholder = '输入单集标题'
              break;
            case 'topic':
              placeholder = '输入主题标题'
              break  
            default:
              break;
          }
          this.autocompletePlaceholder = placeholder
        },
        immediate: true
      }
    },
    methods: {
      getTodayRecommendConfig: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.todayRecommendConfig.list(params).then(res => {
          window.console.log("获取到 todayRecommend config")
          window.console.log(res)
          if (res.data.count > 0) {
            that.nodeForm = res.data.results[0]
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      getTodayRecommend: function () {
        let that = this
        let params = {
          show__slug: that.slug
        }
        that.$api.todayRecommend.list(params).then(res => {
          window.console.log("获取到 todayRecommend")
          window.console.log(res)
          if (res.data.count > 0) {
            that.nodeFormTodayRecommend = res.data.results[0]
            window.console.log("that.nodeFormTodayRecommend:", that.nodeFormTodayRecommend)
          } else {
            window.console.log("未找到相关配置")
          }
        })
      },
      resetForm: function () {
        window.console.log("resetForm")
        this.$refs.nodeForm.resetFields()
      },
      submitTodayRecommendConfig: function () {
        this.$refs.nodeForm.validate((valid) => {
          if (valid) {
            window.console.log(valid)
            this.$api.todayRecommendConfig.update(
              this.nodeForm.id, this.nodeForm
            ).then(res => {
              window.console.log("TodayRecommendConfig更新成功")
              window.console.log(res)
              router.replace({
                name: 'ResultSuccess',
                params: {
                  title: '成功',
                  subTitle: '今日推荐设置已更新',
                  action: {
                    title: '返回今日推荐设置',
                    routeName: 'Recommend'
                  }
                }
              })
            })
          } else {
            window.console.log(valid)
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
          }
        })
      },
      submitTodayRecommend: function () {
        window.console.log(
          "提交表单this.nodeFormTodayRecommend", this.nodeFormTodayRecommend)
        let nodeFormTodayRecommend = {...this.nodeFormTodayRecommend}
        let items = this.nodeFormTodayRecommend.items
        nodeFormTodayRecommend.items = JSON.stringify(items)
        this.$api.todayRecommend.update(
          nodeFormTodayRecommend.id, nodeFormTodayRecommend
        ).then(res => {
          window.console.log("TodayRecommend更新成功")
          window.console.log(res)
        })
      },
      submitForm: function () {
        this.submitTodayRecommend()
        this.submitTodayRecommendConfig()
      },
      handleClick(row) {
        window.console.log(row);
      },
      autocompleteInputChange: function (keyword) {
        window.console.log("autocompleteInputChange", keyword)
        switch (this.cardTypeSelect) {
          case 'episode':
            this.getEpisodes(keyword)
            break;
          case 'topic':
            this.getTopics(keyword)
            break
          default:
            break;
        }
      },
      querySearchAsync: function (queryString, cb) {
        window.console.log("开始过滤查询", queryString)
        switch (this.cardTypeSelect) {
          case 'episode':
            if (!queryString) {
              this.getEpisodes().then(res => {
                cb(res)
              })
            } else {
              let episodes = this.episodes
              let results = episodes
              clearTimeout(this.timeout)
              this.timeout = setTimeout(() => {
                cb(results)
              }, 0.5 * 1000)
            }
            break
          case 'topic':
            if (!queryString) {
              this.getTopics().then(res => {
                cb(res)
              })
            } else {
              let topics = this.topics
              let results = topics
              clearTimeout(this.timeout)
              this.timeout = setTimeout(() => {
                cb(results)
              }, 0.5 * 1000)
            }
            break
          default:
            break
        }
      },
      handleSelect: function (e) {
        window.console.log("点击下拉选项:", e)
        // 检查选中的 episodeId 是否已在列表中
        let included = this.nodeFormTodayRecommend.items.some(function(currentValue) {
          return currentValue.episodeId == e.id
        })
        if (included) {
          Message.error({
            message: '该元素已加入轮播区'
          })
          this.state = '' // 清空输入框内容
        } else {
          this.$set(
            this.nodeFormTodayRecommend.items,
            this.nodeFormTodayRecommend.items.length,
            // {episodeId: e.id}
            {objectType: this.cardTypeSelect, objectId: e.id}
          )
          Message.success({
            message: '成功添加到轮播区'
          })
          this.state = ''
        }
        window.console.log('this.nodeFormTodayRecommend.items:', this.nodeFormTodayRecommend.items)
      },
      getEpisodes: function (keyword) {
        return new Promise((resolve, reject) => {
          let params = {
            show__slug: this.showSlug
          }
          if (keyword) {
            params.search = keyword
          }
          this.$api.episode.list(params)
          .then(res => {
            window.console.log("获取指定 EPISODE LIST 成功", res.data)
            if (res.data.count > 0) {
              let results = res.data.results
              let theEpisodes = []
              for (let i = 0; i < results.length; i++) {
                const item = results[i];
                window.console.log("ITEM:", item)
                let obj = {} // 临时对象
                obj['value'] = item['title']
                obj['id'] = item['id']
                window.console.log("OBJ:", obj)
                theEpisodes.push(obj)
              }
              window.console.log(`theEpisodes:`, theEpisodes)
              // this.episodes = theEpisodes
              // window.console.log(`this.episodes:`, this.episodes)
              resolve(theEpisodes)
            }
          })
          .catch(err => {
            reject(err)
          })
        })
      },
      getTopics: function (keyword) {
        return new Promise((resolve, reject) => {
          let params = {
            show__slug: this.showSlug
          }
          if (keyword) {
            params.search = keyword
          }
          this.$api.topic.list(params)
          .then(res => {
            window.console.log("获取指定 TOPIC LIST 成功", res.data)
            if (res.data.count > 0) {
              let results = res.data.results
              let theTopics = []
              for (let i = 0; i < results.length; i++) {
                const item = results[i];
                window.console.log("ITEM:", item)
                let obj = {} // 临时对象
                obj['value'] = item['title']
                obj['id'] = item['id']
                window.console.log("OBJ:", obj)
                theTopics.push(obj)
              }
              window.console.log(`theTopics:`, theTopics)
              resolve(theTopics)
            }
          })
          .catch(err => {
            reject(err)
          })
        })
      },
      allowDrop: function (draggingNode, dropNode, Type) {
        // 检查是否能够被放下（拖放时）
        if (Type == 'inner') {
          return false
        } else {
          return true
        }
      },
      checkChange: function (data, node) {
        window.console.log("checkChange:")
        window.console.log(data, node)
        this.checkedItems = this.$refs.nodeFormTodayRecommend.getCheckedNodes()
      },
      removeCheckedItems: function () {
        let current = this.nodeFormTodayRecommend.items
        window.console.log('current:', current)
        let toRemove = this.checkedItems
        window.console.log('toRemove:', toRemove)
        let newArr = []
        for (let i = 0; i < current.length; i++) {
          let inRemove = false // 是否在应删列表中
          const item = current[i]
          for (let i2 = 0; i2 < toRemove.length; i2++) {
            const item2 = toRemove[i2]
            if (item2.objectId == item.objectId) {
              inRemove = true
            }
          }
          if (!inRemove) {
            newArr.push(item)
          }   
        }
        window.console.log('newArr:', newArr)
        this.nodeFormTodayRecommend.items = newArr
        this.checkedItems = []
      },
    },
    mounted () {
      this.getTodayRecommendConfig()
      this.getTodayRecommend()
    }
  }
</script>

<style lang="css">
  .alert-container {
    margin-bottom: 15px;
  }
  .page-title {
    /* padding-bottom: 15px; */
    border-bottom: 1px solid #ededed;
    /* margin-bottom: 10px; */
  }
  h3 {
    margin: 0;
  }
  .block-container {
    margin-bottom: 15px;
  }
  .right {
    text-align: right;
  }
  .last-item {
    margin-bottom:0;
  }
  .el-select .el-input {
    width: 100px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
  .custom-container {
    margin-top: 5px;
    line-height: 0;
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    align-content: center;
    vertical-align: middle;
    /* align-items: flex-end; */
  }
  .info-bar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #9a9da3;
    font-size: 0.85em;
  }
  .tree-container {
    border: 1px dashed #DCDFE6;
    padding: 5px;
    border-radius: 4px;
  }
</style>
